import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MenuController } from '@ionic/angular';

import { AuthService } from './core/services/login/auth.service';
 
import { ThemeService } from './core/services/theme.service';
import { OnboardingService } from './core/services/onboarding.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  showMenu = true;
  showTabBar = true;

  // Menu dinamico
  appPages = [
    { title: 'Dashboard', url: '/main', icon: 'home' },
    { title: 'Impostazioni', url: '/settings', icon: 'settings' },
    { title: 'Dettagli', url: '/details', icon: 'information-circle' },
  ];

  private readonly hideTabRoutes = ['/login', '/orderdetail'];

  constructor(
    private router: Router,
    private authService: AuthService,
    private menuCtrl: MenuController,
    private onboarding: OnboardingService,
    private theme: ThemeService
  ) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const currentUrl = event.urlAfterRedirects || event.url;
        const isLogin = currentUrl.includes('/login');
        this.showMenu = !isLogin;

        // Nascondi tab bar su alcune route
        this.showTabBar = !this.hideTabRoutes.some((path) => currentUrl.includes(path));
      });
  }

  async ngOnInit() {
    // Applica subito il tema se salvato
  //  const info = await this.onboarding.getCompanyInfo();
  //  if (info) {
  //    this.theme.applyCompanyTheme(info.colore1, info.colore2, info.logo);
  //  }

   
  }

  openMenu() {
    this.menuCtrl.enable(true, 'first');
    this.menuCtrl.open('first');
  }

  logout() {
    this.authService.logout();
    this.menuCtrl.close();
    this.router.navigate(['/login']);
  }
}
